import QueryString, { type ParsedQs } from "qs";

export const useQueryParams = <T extends ParsedQs = ParsedQs>() => {
	const { search = "" } = window.location;
	return QueryString.parse(search.substr(1)) as T;
};

export default useQueryParams;
